import { SxProps, Theme } from "@mui/material";

export const radioButtonReportSx: SxProps<Theme> = {
  "& .MuiSvgIcon-root": {
    fontSize: 22,
  },
};
